module.exports = __webpack_public_path__ + "static/img/img_5.870582f7.jpg";